import 'client-only';

import { atom, useAtom } from 'jotai';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const submittingFormAtom = atom(false);

const pathAtom = atom('');
const searchParamsAtom = atom('');

export const useSubmittingForm = () => {
  const [submittingForm, setSubmittingForm] = useAtom(submittingFormAtom);

  const [path, setPath] = useAtom(pathAtom);
  const [searchParams, setSearchParams] = useAtom(searchParamsAtom);

  const currentPath = usePathname();
  const currentSearchParams = useSearchParams();

  // Watch for changes to the path and search params. When either of these update, reset the submitting form state.
  useEffect(() => {
    if (
      currentPath === path &&
      currentSearchParams.toString() === searchParams
    ) {
      return;
    }

    setPath(currentPath);
    setSearchParams(currentSearchParams.toString());
    setSubmittingForm(false);
  }, [
    currentPath,
    currentSearchParams,
    path,
    searchParams,
    setSubmittingForm,
    setPath,
    setSearchParams,
  ]);

  return {
    submittingForm,
    setSubmittingForm,
  };
};
